import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export interface ConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function Confirmation(props: ConfirmationProps) {
  const { onCancel, onConfirm } = props;
  return (
    <Dialog open onClose={onCancel}>
      <DialogTitle>Are you sure you want to Submit?</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Please make sure that you only click submit when you are happy that
          you have answered all the questions otherwise you will show that you
          are mapped to the lowest categories of maturity for your product.
          Nexus will save any answers you have added without you clicking
          submit.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
